import React from 'react';
import { Dialog, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function GameOverDialog({ open, winner, yourIndex, reason }) {
    const { t } = useTranslation();

    let message;
    if (reason === 'draw') {
        message = t('APPLICATIONS.CONNECT4.DRAW');
    } else if (reason === 'disconnect') {
        message = t('APPLICATIONS.CONNECT4.OPPONENT_DISCONNECTED');
    } else if (reason === 'forfeit' && winner === yourIndex) {
        message = t('APPLICATIONS.CONNECT4.OPPONENT_FORFEIT');
    } else if (winner === yourIndex) {
        message = t('APPLICATIONS.CONNECT4.YOU_WIN');
    } else {
        message = t('APPLICATIONS.CONNECT4.YOU_LOSE');
    }

    return (
        <Dialog open={open}>
            <DialogTitle sx={{ textAlign: 'center', px: 8, py: 4 }}>
                <Typography variant="h4" component="span">
                    {message}
                </Typography>
            </DialogTitle>
        </Dialog>
    );
}
